/**
 * Return whether browser is on iphone or not
 * @param  userAgent
 * @returns {boolean}
 */
const isIPhone = userAgent => {
  if (userAgent.indexOf('Safari') > -1 && userAgent.indexOf('iPhone') > -1) {
    return true;
  }
  return false;
};

export default isIPhone;
